
import { useContext } from 'react';
import { PlusIcon } from "@heroicons/react/solid";

import Collapse from '../../../qg-components/src/libs/Collapse';
import TextArea from '../../../qg-components/src/libs/textarea';
import CopyToClipboard from 'react-copy-to-clipboard';

import { getSeverityStyle } from '../utils/helper';
import { viewImgContext } from "..";

const DataCollapse = ({className}) => {
  const { showActionNoteBox, confirmCopySlideNote, studyInfo } = useContext(viewImgContext);

  const openEditDialog = ( type ) => {
    showActionNoteBox(type)
  };

  const onCopy = (info) => {
    confirmCopySlideNote(info)
  };

  const handleNoteClick = (e, item, index) => {
    // setFindingInfo({
    //   item,
    //   index,
    // })
  }

  return (
    <div className={`w-72 h-full bg-white overflow-y-scroll scrollbar absolute top-0 z-20 ${className}`}>
      <Collapse header="study Data" headerClass='text-sm font-serif'>
        <StudyRender study={studyInfo?.Study}></StudyRender>
      </Collapse>
      <Collapse header="Animal Data" headerClass='text-sm font-serif'>
        <AnimalRender animal={studyInfo?.Animal}></AnimalRender>
      </Collapse>
      <Collapse header='Slide Data' headerClass='text-sm font-serif'>
        <SlideRender slide={studyInfo}></SlideRender>
      </Collapse>
      <Collapse header='Interim Notes' headerClass='text-sm font-serif' headerRightIcon={<PlusIcon onClick={() => {openEditDialog('InterimSlideNote')}} className='w-3 mr-3 cursor-pointer'></PlusIcon>}>
        <NoteRender 
         note={studyInfo?.InterimSlideNote} 
         onCopy={onCopy} 
         showCopy={true}
         handleClick={handleNoteClick}
        ></NoteRender>
      </Collapse>
      <Collapse header='Slide Notes' headerClass='text-sm font-serif' headerRightIcon={<PlusIcon onClick={() => {openEditDialog('SlideNote')}} className='w-3 mr-3 cursor-pointer'></PlusIcon>}>
        <NoteRender 
         note={studyInfo?.SlideNote} 
         showCopy={false}
         handleClick={handleNoteClick}
        ></NoteRender>
      </Collapse>
      
      <Collapse header='SlideObservation Notes' headerClass='text-sm font-serif' headerRightIcon={<PlusIcon onClick={() => {openEditDialog('SlideObservation')}} className='w-3 mr-3 cursor-pointer'></PlusIcon>}>
        <NoteRender 
         note={studyInfo?.SlideObservation} 
         showCopy={false} 
         handleClick={handleNoteClick}
        ></NoteRender>
      </Collapse>
      
    </div>
  )
};

export default DataCollapse;

const StudyRender = ({study}) => {
  if(!study) {
    return <></>
  };

  const renderArr = [{
    title: "Species",
    key: study.Species
  }, {
    title: "Sponsor",
    key: study.Sponsor
  },{
    title: "Study",
    key: study.StudyName
  },{
    title: "Strain",
    key: study.Strain
  },{
    title: "StudyName",
    key: study.StudyName
  },{
    title: "TestFacility",
    key: study.TestFacility
  },{
    title: "Type",
    key: study.Type
  }];

  return (
    <ul className='w-full h-full'>
      {
        renderArr.map((item, index) => (
          <li className='w-full flex' key={index}>
            <div className={`w-6/12 p-3 text-right text-xs border-r-2 border-gray-200 ${index % 2 === 0 ? 'bg-gray-100': 'bg-white'}`}>{item.title}</div>
            <div className={`w-6/12 p-3 text-left text-xs ${index % 2 === 0 ? 'bg-gray-100': 'bg-white'}`}>{item.key}</div>
          </li>
        ))
      }
    </ul>
  )
};

const AnimalRender = ({animal}) => {
  if(!animal) {
    return <></>
  };

  const renderArr = [{
    title: "AnimalName",
    key: animal.AnimalName
  }, {
    title: "Administration",
    key: animal.Administration
  },{
    title: "Dose",
    key: animal.Dose
  },{
    title: "Group",
    key: animal.Group
  },{
    title: "SacrificePeriod",
    key: animal.SacrificePeriod
  },{
    title: "Sex",
    key: animal.Sex
  },{
    title: "Stain",
    key: animal.Stain
  }];

  return (
    <ul className='w-full h-full'>
      {
        renderArr.map((item, index) => (
          <li className='w-full flex' key={index}>
            <div className={`w-6/12 p-3 text-right text-xs border-r-2 border-gray-200 ${index % 2 === 0 ? 'bg-gray-100': 'bg-white'}`}>{item.title}</div>
            <div className={`w-6/12 p-3 text-left text-xs ${index % 2 === 0 ? 'bg-gray-100': 'bg-white'}`}>{item.key}</div>
          </li>
        ))
      }
    </ul>
  )
};

const SlideRender = ({slide}) => {

  if(!slide) {
    return <></>
  };

  const renderArr = [{
    title: "Image File Name",
    key: slide.ImageFileName
  }, {
    title: "Slide Name",
    key: slide.SlideName
  },{
    title: "Study",
    key: slide.Study.StudyName
  },{
    title: "Animal",
    key: slide.Animal.AnimalName
  },{
    title: "Block",
    key: slide.Vlock
  },{
    title: "Organ",
    key: slide.Organ
  },{
    title: "Dose",
    key: slide.Animal.Dose
  },{
    title: "Stain",
    key: slide.Animal.Stain
  }, {
    title:"Scanner",
    key: slide.Scanner
  },{
    title: "Magnification",
    key: slide.Magnification
  }];

  return (
    <ul className='w-full h-full'>
      {
        renderArr.map((item, index) => (
          <li className='w-full flex' key={index}>
            <div className={`w-6/12 p-3 text-right text-xs border-r-2 border-gray-200 ${index % 2 === 0 ? 'bg-gray-100': 'bg-white'}`}>{item.title}</div>
            <div className={`w-6/12 p-3 text-left text-xs ${index % 2 === 0 ? 'bg-gray-100': 'bg-white'}`}>{item.key}</div>
          </li>
        ))
      }
    </ul>
  )
};


/**
 * Findings都在这里展示
 * @param {obj} param0.note 数组, param0.handleXXX 回调函数
 * @returns 
 */
const NoteRender = ({ note, handleClick, handleMouseOver, showCopy, onCopy }) => {
  // 当没有findings的时候，显示什么
  const notePlaceHolder = "No Findings yet."

  // 搞定findings
  let findings
  if (!note || !note.length) {
    findings = <div className='w-full border p-5 text-xs text-center text-gray-400 rounded-md mb-1'>{notePlaceHolder}</div>
  } else {
    // 定义textClass
    const textClass = "w-full flex text-xs antialiased ordinal tracking-wider leading-relaxed";
    let reNote = note
    findings = <>
      {
        reNote.map((item, index) => {
          const severityClass = getSeverityStyle(item.Severity)
          return (
            <ul key={index} className={`${severityClass} 
              w-full h-full mb-1 border rounded-md hover:bg-gray-100`}
              onClick={
                (e) => {
                  handleClick && handleClick(e, item, index)
                }
              }
              onMouseOver={
                (e) => {
                  handleMouseOver && handleMouseOver(e, item, index)
                }
              }
            >
              <li className='w-full p-3 text-current font-serif' key={index}>
                <h3 className='font-semibold text-sm'>Finding {index + 1} has:</h3>
                <div className={`${textClass}`}>
                  <div className='text-gray-400 mr-1.5'>Finding:</div>
                  <div>{item.Finding}</div>
                </div>
                <div className={`${textClass}`}>
                  <div className='text-gray-400 mr-1.5'>FindingINHAND:</div>
                  <div>{item.FindingInhand}</div>
                </div>
                <div className={`${textClass}`}>
                  <div className='text-gray-400 mr-1.5'>Severity:</div>
                  <div>{item.Severity}</div>
                </div>
                <div className={`${textClass}`}>
                  <div className='text-gray-400 mr-1.5'>ServerityInhand:</div>
                  <div>{item.ServerityInhand}</div>
                </div>
                <div className={`${textClass}`}>
                  <div className='text-gray-400 mr-1.5'>Directionality:</div>
                  <div>{item.Directionality}</div>
                </div>
                <div className={`${textClass}`}>
                  <div className='text-gray-400 mr-1.5'>Laterality:</div>
                  <div>{item.Laterality}</div>
                </div>

                { showCopy ?
                <CopyToClipboard text={JSON.stringify(item)}
                onCopy={onCopy}>
                <span className='text-blue-500 font-semibold text-xs underline cursor-pointer'>confirm and copy to slide note</span>
                </CopyToClipboard>: null }
              </li>
            </ul>
          )
        }
        ) // map call end
      }
    </>
  }

  return (
    <div className="flex flex-col">
      { findings }
      <h3 className='font-serif font-medium text-sm mt-3'>Additional comments:
        <TextArea placeholder="Write some text here" onKeyUp={(e) => {
          console.log(e)
        }}>{  }</TextArea>
      </h3>
    </div>
  )
}
